import { DsProjectStatusEnum } from '../enums/ds-project-status.enum';

export const DS_PROJECT_STATUS_LABEL = [
  {
    label: `organisationsProjectList.${DsProjectStatusEnum.completed}`,
    color: '#A55EBD',
  },
  { label: `organisationsProjectList.${DsProjectStatusEnum.archived}`, color: '#CBC1C1' },
  { label: `organisationsProjectList.${DsProjectStatusEnum.waiting}`, color: '#FF8819' },
  {
    label: `organisationsProjectList.${DsProjectStatusEnum.ongoing}`,
    color: '#00A8C1',
  },
  { label: `organisationsProjectList.${DsProjectStatusEnum.failed}`, color: 'red' },
];
